import { request, login_request, patch_request, patch_get } from './request';
import request_body from './request_body';
// import * as echarts from "echarts";


export default { 
	request_body,
	setRequestUrl(url) {
		window.localStorage.setItem("rqurl", url);
		// request_body.url = url;
	},
	getPatchUrl() {
		return "https://update.91mgame.com";
	},
	async login(data) {
		request_body.logout();
		request_body.login(data);
	},
	async loginAdmin(form) {
		return login_request("/azadmin/login_admin", form, "application/json");
	},
	async getAdvertisers() {
		return request("/azadmin/advertisers");
	},
	async addAdvertiser(advertiser_id) {
		return request("/azadmin/add_advertiser", { advertiser_id }, "application/json");
	},
	// async getMaterialMonthInventory(search, page, len, month) {
	// 	return request("/project/get_material_month_inventory", {search, page, len, month});
	// },
	async getReports(params) {
		return request("/azadmin/get_reports", params, "application/json");
	},
	async getGameReports(params) {
		return request("/azadmin/get_game_reports", params, "application/json");
	},
	async getGameAdTypeReports(params) {
		return request("/azadmin/get_game_ad_type_reports", params, "application/json");
	},
	async getSumReports(params) {
		return request("/azadmin/get_sum_reports", params, "application/json");
	},
	async getApps() {
		return request("/azadmin/get_apps");
	},
	async bindApp(package_name, app_id) {
		return request("/azadmin/bind_app", { package_name, app_id }, "application/json");
	},
	async setUmKey(appkey, app_id) {
		return request("/azadmin/set_umkey", { appkey, app_id }, "application/json");
	},
	async getAppRoas(package_name, start_date, end_date, country) {
		return request("/azadmin/get_app_roas", { package_name, start_date, end_date, country }, "application/json");
	},
	async getAppGallery() {
		return request("/azadmin/get_app_gallery");
	},
	async addAppGallery(form) {
		return request("/azadmin/add_app_gallery", form, "application/json");
	},
	async getCountries() {
		return request("/azadmin/get_countries");
	},
	async getEarningReports(param) {
		return request("/azadmin/get_earnings_reports", param, "application/json");
	},
	async getAdsAccount() {
		return request("/azadmin/get_ads_accounts");
	},
	async updateAdvertiserRemark(param) {
		return request("/azadmin/update_advertiser_remark", param, "application/json");
	},
	async saveAdmin(param) {
		return request("/azadmin/save_admin", param, "application/json");
	},
	async getAdmin() {
		return request("/azadmin/get_admin");
	},
	async getAdminAdvertisers() {
		return request("/azadmin/get_admin_advertisers");
	},
	async saveAdminAdvertisers(param) {
		return request("/azadmin/save_admin_advertisers", param, "application/json");
	},
	async getPrivileges() {
		return request("/azadmin/get_privileges");
	},
	async getOverview(param) {
		return request("/azadmin/get_overview", param, "application/json");
	},
	async changePassword(password) {
		return request("/azadmin/change_password", {password}, "application/json");
	},

	async createAudiencePackage(params) {
		return request("/azadmin/create_audience_package", params, "application/json");
	},
	async syncAudiencePackage(advertiser_id) {
		return request("/azadmin/sync_audience_package", { advertiser_id }, "application/json");
	},
	async getAudiencePackage(advertiser_id) {
		return request("/azadmin/get_audience_package", { advertiser_id }, "application/json");
	},
	async getPosition(advertiser_id) {
		return request("/azadmin/get_position", { advertiser_id }, "application/json");
	},
	async getPositionDetail(advertiser_id, creative_size_id) {
		// let data = window.localStorage.getItem(`position_detail_${advertiser_id}_${creative_size_id}`)
		// if (data != null && data != "") {
		// 	return {
		// 		err: 0,
		// 		data: {
		// 			detail: data
		// 		}
		// 	};
		// }
		let rs = await request("/azadmin/query_position_detail", { advertiser_id, creative_size_id }, "application/json");
		// if (rs.err == 0) {
		// 	window.localStorage.setItem(`position_detail_${advertiser_id}_${creative_size_id}`, rs.data.detail);
		// }
		return rs;
	},
	async queryAssets(asset_type, width, height) {
		return request("/azadmin/query_assets", {asset_type, width, height}, "application/json");
	},
	async getCollectionTasks() {
		return request("/azadmin/get_collection_tasks");
	},
	async getGameCollectionTasks(game_id) {
		return request("/azadmin/get_game_collection_tasks", {game_id}, "application/json");
	},
	async updateCollectionTasks(task_id, enabled) {
		return request("/azadmin/update_collection_tasks", {task_id, enabled}, "application/json");
	},
	async getCollectionOperations(task_id, game_id, page, len) {
		return request("/azadmin/get_collection_operations", {task_id, game_id, page, len}, "application/json");
	},
	async updateCollectionAdvertisers(task_id, advertisers) {
		return request("/azadmin/update_collection_advertisers", {task_id, advertisers}, "application/json");
	},
	async queryPositionPrice(advertiser_id, creative_size_id, price_type) {
		return request("/azadmin/query_position_price", { advertiser_id, creative_size_id, price_type }, "application/json");
	},
	async createAds(params) {
		return request("/azadmin/create_ads", params, "application/json");
	},
	async searchAssets(params) {
		return request("/azadmin/search_assets", params, "application/json");
	},
	async addCollection(params) {
		return request("/azadmin/add_collection", params, "application/json");
	},
	async delCollection(id) {
		return request("/azadmin/del_collection", {id}, "application/json");
	},
	async getAds(page, page_len) {
		return request("/azadmin/get_ads", {page, page_len}, "application/json");
	},
	async getAppGroup() {
		return request("/azadmin/get_app_group", {}, "application/json");
	},
	async addAppGroup(params) {
		return request("/azadmin/add_app_group", params, "application/json");
	},
	async deleteAppGroup(id) {
		return request("/azadmin/delete_app_group", {id}, "application/json");
	},
	async getRoasPeriodData(package_name, date_start, date_end, country) {
		return request("/azadmin/get_roas_period_data", {package_name, date_start, date_end, country}, "application/json");
	},
	async saveBudgetPlan(form) {
		return request("/azadmin/save_budget_plan", form, "application/json");
	},
	async getBudgetPlans() {
		return request("/azadmin/get_budget_plans");
	},
	async deleteBudgetPlan(pid) {
		return request("/azadmin/delete_budget_plan", {pid}, "application/json");
	},
	async getBudgetLogs(pid, page, page_len) {
		return request("/azadmin/get_budget_logs", {pid, page, page_len}, "application/json");
	},
	async searchAds(ad_type, value) {
		return request("/azadmin/search_ads", {ad_type, value}, "application/json");
	},
	async getWhiteAds(ad_type, value, page, len) {
		return request("/azadmin/get_white_ads", {ad_type, value, page, len}, "application/json");
	},
	async addWhite(id, advertiser_id, ad_type) {
		return request("/azadmin/add_white", {id, advertiser_id, ad_type}, "application/json");
	},
	async delWhite(id, advertiser_id, ad_type) {
		return request("/azadmin/del_white", {id, advertiser_id, ad_type}, "application/json");
	},
	async getGameTasks(params) {
		return request("/azadmin/get_game_tasks", params, "application/json");
	},
	async updateTaskConversionCost(params) {
		return request("/azadmin/update_task_conversion_cost", params, "application/json");
	},
	async updateTaskStatus(params) {
		return request("/azadmin/update_task_status", params, "application/json");
	},
	async updateCampaignBudget(params) {
		return request("/azadmin/update_campaign_budget", params, "application/json");
	},
	async updateCampaignStatus(params) {
		return request("/azadmin/update_campaign_status", params, "application/json");
	},
	async saveTomorrowBudgetPlan(params) {
		return request("/azadmin/save_tomorrow_budget_plan", params, "application/json");
	},
	async getTomorrowBudgetPlan(pid) {
		return request("/azadmin/get_tomorrow_budget_plan", {pid}, "application/json");
	},
	async getCostReports(package_name, start_date, end_date) {
		return request("/azadmin/get_cost_reports", {package_name, start_date, end_date}, "application/json");
	},
	async getLinkTokens(advertiser_id) {
		return request("/azadmin/get_link_tokens", {advertiser_id}, "application/json");
	},
	async saveLinkTokens(params) {
		return request("/azadmin/save_link_tokens", params, "application/json");
	},

	async deletePatch(id) {
		return patch_request("/patch/delete_patch", {id}, "application/json");
	},
	async getPatch(version, page, limit) {
		return patch_request("/patch/get_patch", {version, page, limit}, "application/json");
	},
	async getPatchVersions() {
		return patch_request("/patch/get_patch_version");
	},
	async getPatchExclude(id) {
		return patch_get("/patch/get_patch_exclude", {id});
	},
	async savePathExclude(params) {
		return patch_request("/patch/save_patch_exclude", params, "application/json");
	},
}
